import React from "react";
import * as core from "@material-ui/core";
import { useTranslation } from "react-i18next";

const WorkInformation = (props) => {
  const { t } = useTranslation();
  const { touched, errors, values, handleBlur, handleChange } = props;
  let beginDate = values.beginDate ? values.beginDate.substring(0, 10) : '';
  let endDate = values.endDate ? values.endDate.substring(0, 10) : '';

  return (
    <core.Card>
      <core.CardHeader title={t("pages.workrequest.workInformation.stepname")} />
      <core.Divider />
      <core.CardContent>
         <>
            <core.Grid container spacing={1}>
              <core.Grid item md={8} xs={8}>
                <core.TextField 
                fullWidth
                InputLabelProps={{shrink: true,}}
                  label={t("workerRequest.title")}
                  name="title"
                  error={Boolean(touched.title && 
                         errors.title)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.title} />
              </core.Grid>
              <core.Grid item md={4} xs={4}>
                <core.TextField 
                fullWidth
                  label={t("workerRequest.shiftCount")}
                  name="shiftCount"
                  type="number"
                  InputLabelProps={{ shrink: true, }}
                  error={Boolean(touched.shiftCount && errors.shiftCount)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.shiftCount} />
              </core.Grid>
              <core.Grid item md={6} xs={12}>
                <core.TextField fullWidth
                  label={t("workerRequest.beginDate")}
                  name="beginDate"
                  type="date"
                  InputLabelProps={{ shrink: true, }}
                  error={Boolean(touched.beginDate && errors.beginDate)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={beginDate} />
              </core.Grid>
              <core.Grid item md={6} xs={12}>
                <core.TextField fullWidth
                  label={t("workerRequest.endDate")}
                  name="endDate"
                  type="date"
                  InputLabelProps={{ shrink: true, }}
                  error={Boolean(touched.endDate && errors.endDate)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={endDate} />
              </core.Grid>
            <core.Grid item md={12} xs={12}>
                <core.TextField 
                 fullWidth
                 InputLabelProps={{shrink: true,}}
                  label={t("workerRequest.workDescription")}
                  name="workDescription"
                  error={Boolean(touched.workDescription && errors.workDescription)}
                  onBlur={handleBlur}
                  onChange={handleChange}
                  value={values.workDescription} />
              </core.Grid>
            </core.Grid>
           
            {/* This state
            <pre>{JSON.stringify(values, null, 2)}</pre>
            <br />
            <pre>{JSON.stringify(props.values, null, 2)}</pre> */}
            </>
      </core.CardContent>
      <core.Divider />
    </core.Card>
  );
};

export default WorkInformation;
